var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value !== undefined)?_c('div',[(_vm.value === true)?_vm._t("true",function(){return [_vm._v(" "+_vm._s(_vm.$t('common.yes'))+" ")]}):_vm._e(),(_vm.value === false)?_vm._t("false",function(){return [_vm._v(" "+_vm._s(_vm.$t('common.no'))+" ")]}):_vm._e()],2):_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }